import Joi from 'joi';
import PropTypes from 'prop-types';
import Form from '../../common/form';

import * as utils from '../../../utils/utilities';

class RTPhotograpicRecord extends Form {
	state = {
		data: { images: [] },
		errors: {},
		loading: false,
		progress: 0,
		places: [],
	};

	static propTypes = {
		onProceed: PropTypes.func,
	};

	schema = {
		images: Joi.array().min(1).required().label('Images'),
	};

	doSubmit = (): void => {
		const props: any = this.props;
		props.onProceed(this.state.data.images);
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit} className="p-3">
				{this.renderFileInput({
					max: 16,
					multiple: true,
					name: 'images',
					accept: 'image/*,application/pdf',
					label: 'Images',
					sublabel: 'Upload RT (Weld) Photograpic Data',
					types: utils.getFileUploadTypes(),
				})}

				<div className="d-flex justify-content-end">
					{this.renderButton('Proceed')}
				</div>
			</form>
		);
	}
}

export default RTPhotograpicRecord;
